var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-positions"},[_c('bim-text',{attrs:{"type":"main"}},[_vm._v("Топ позиций:")]),_vm._v(" "),_c('ol',{staticClass:"top-positions__ol"},_vm._l((_vm.topPositions),function(position){return _c('li',{key:position,staticClass:"top-positions__li"},[_c('bim-text',{attrs:{"type":"main"}},[_vm._v(_vm._s(position))])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }